/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { ApiResParserService } from '@api/services/api-res-parser/api-res-parser.service';
import { Options } from '@api/models/options';
import { ApiService } from '@api/services/api/api.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import {
  HawkScanDTO,
  IdentificationLinkDTO,
  IdentificationVerifyDTO
} from '../../models';
import { delay, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApiMockService extends ApiService {
  protected mockUrl = `${location.protocol}//${location.hostname}:3100/qinetic/v1`;

  private identificationVerifyAttemps = 0;

  constructor(
    protected http: HttpClient,
    protected parser: ApiResParserService
  ) {
    super(http, parser);
  }

  // postSecurityLogon(req: AuthenticateDTO, options?: Options): Observable<void> {
  //   return this.http.get<void>(
  //     `${this.mockUrl}/security/authenticate?token=${req['uuid-info']}`,
  //     options
  //   );
  // }

  // getSecurityUserData(options?: Options): Observable<UserDataDTO> {
  //   return this.listToOne<UserDataDTO>(
  //     this.http.get<UserDataDTO>(`${this.mockUrl}/security/user`, options)
  //   );
  // }

  // getLabels(options?: Options): Observable<LabelListDTO> {
  //   return this.http
  //     .get<any>(`${this.mockUrl}/labels`, options)
  //     .pipe(map(res => ({ labels: res })));
  // }

  // getDomain(code: string, options?: Options): Observable<DomainListDTO> {
  //   return this.http
  //     .get<DomainItemDTO[]>(`${this.mockUrl}/domains/${code}`)
  //     .pipe(map(res => ({ domainList: res })));
  // }

  // getPosition(positionId: string, options?: Options): Observable<PositionDTO> {
  //   return this.listToOne<PositionDTO>(
  //     this.http.get<PositionDTO>(
  //       `${this.mockUrl}/positions/${positionId}`,
  //       options
  //     )
  //   );
  // }

  // getWizard(
  //   positionId: string,
  //   wizardCode: string,
  //   options?: Options
  // ): Observable<WizardDTO> {
  //   return this.listToOne<WizardDTO>(
  //     this.http.get<WizardDTO>(
  //       `${this.mockUrl}/workflow/${positionId}/wizards/${wizardCode}`,
  //       options
  //     )
  //   ).pipe(map(res => this.parser.wizard(res)));
  // }

  // putWizardStepNext(
  //   positionId: string,
  //   wizardCode: string,
  //   stepCode: string,
  //   options?: Options
  // ): Observable<WizardStepNextOutputDTO> {
  //   return of(true).pipe(
  //     delay(1000),
  //     map(() => ({ outcome: 'OK' }))
  //   );
  // }

  // getSurvey(
  //   positionId: string,
  //   surveyCode: string,
  //   options?: Options
  // ): Observable<SurveyDTO[]> {
  //   return this.http
  //     .get<SurveyDTO[]>(`${this.mockUrl}/surveys/${surveyCode}`, options)
  //     .pipe(map(res => this.parser.surveys(res)));
  // }

  // putSurvey(
  //   positionId: string,
  //   surveyCode: string,
  //   body: SurveyUpdateDTO,
  //   options?: Options
  // ): Observable<SurveyDTO> {
  //   return this.http
  //     .get<SurveyDTO>(`${this.mockUrl}/surveys/${surveyCode}`, options)
  //     .pipe(delay(1000));
  // }

  // getForm(
  //   positionId: string,
  //   formCode: string,
  //   options?: Options
  // ): Observable<FormDTO[]> {
  //   return this.http.get<FormDTO[]>(
  //     `${this.mockUrl}/forms/${formCode}`,
  //     options
  //   );
  // }

  // postForm(
  //   positionId: string,
  //   formCode: string,
  //   body: FormUpdateDTO,
  //   options?: Options
  // ): Observable<any> {
  //   return this.http
  //     .get<FormDTO[]>(`${this.mockUrl}/forms/${formCode}`, options)
  //     .pipe(delay(1000));
  // }

  // getChecklist(
  //   positionId: string,
  //   options?: Options
  // ): Observable<ChecklistDTO> {
  //   return this.listToOne<ChecklistDTO>(
  //     this.http.get<ChecklistDTO>(`${this.mockUrl}/checklists/5295`, options)
  //   );
  // }

  // getChecklistDocumentDownload(
  //   positionId: string,
  //   docId: string,
  //   options?: Options
  // ): Observable<any> {
  //   return this.http.get(`https://www.orimi.com/pdf-test.pdf`, options);
  // }

  // postChecklistDocumentUpload(
  //   positionId: string,
  //   docId: string,
  //   body: any,
  //   options?: Options
  // ): Observable<number> {
  //   return of(2).pipe(delay(2000));
  // }

  // postChecklistDocumentOverride(
  //   positionId: string,
  //   docId: string,
  //   fileId: string,
  //   body: any,
  //   options?: Options
  // ): Observable<number> {
  //   return of(2).pipe(delay(2000));
  // }

  getChecklistDocumentScan(
    positionId: string,
    docId: string,
    options?: Options
  ): Observable<HawkScanDTO> {
    return of<HawkScanDTO>({
      templates: [
        {
          qualityIndex: 1,
          documentPage: 'F',
          score: 0.999,
          filePage: 1,
          documentTypeCode: 'CAR',
          fields: [
            {
              field: {
                key: 'DataDiEmissione',
                value: '',
                imagePath: 'wholepage_0',
                confidence: 0.0
              }
            },
            {
              field: {
                key: 'Cognome',
                value: 'Il mio cognome',
                imagePath: 'wholepage_1',
                confidence: 0.0
              }
            },
            {
              field: {
                key: 'DataDiNascita',
                value: '',
                imagePath: 'wholepage_2',
                confidence: 0.0
              }
            },
            {
              field: {
                key: 'LuogoDiNascita',
                value: 'FOTOGRAFIA',
                imagePath: 'wholepage_3',
                confidence: 0.0
              }
            },
            {
              field: {
                key: 'Nome',
                value: '',
                imagePath: 'wholepage_4',
                confidence: 0.0
              }
            }
          ]
        }
      ],
      message: 'File processed in 5707 msecs',
      outcome: 'OK'
    }).pipe(delay(5000));
  }

  // getRecognitionUrl(
  //   provider: string,
  //   options?: Options
  // ): Observable<{ url: string }> {
  //   return of({ url: '/assets/demo/recognition.html' });
  // }

  // postReport(
  //   positionId: string,
  //   reportCode: string,
  //   body: ReportRequestDTO,
  //   options?: Options
  // ): Observable<any> {
  //   return this.http.get(`https://www.orimi.com/pdf-test.pdf`, options);
  // }

  postIdentificationLink(
    method: string,
    body: {
      businessId: string;
      ndg: string;
    },
    options?: Options
  ): Observable<IdentificationLinkDTO> {
    return of({
      // consumerUrl: './assets/demo/recognition.html',
      consumerUrl:
        // eslint-disable-next-line max-len
        'https://dcj-test.crif.com/cff-brk-dobstd/web/fe/index.html?apt=Wf_eP2GkrJ4nPU8Zst9Rc6swBqgYn8K8nuwJJIjzfZNC_tJMSWabUnmtzqcUZvnETG3TG-nScgaGtzmxqiWQp5cLI6vjsvupUPGyNU3j9nCDR5jj6W_jAThyEU0FINKKHvkRgq4hkgz5hJPPZSZu7p2vkxo10Y94_EKQAHJ1Rf9VrVfAokLKG5t1cMIPKB8iVmKQWVoP08d1_kNgfPled1rdnf3sXx9dKGFORkZkaR_7S5kxgbpoTypCOnzWYziigTE2toPqv1vB9COOMUCVo2fccV54MTsqkTRCd7-1-keVrmDZiDScgxk3rfO2XVluO8ocAzE5NHldEWHrUslq1EGO58IKG9LCwVJ28KIWdneLMeIu5PJ_iFGNfRG06hVuXun5QSAwjH3eUo7Uq-ptm4KJyJfxvDIjM7DNuriC9fZxW5VzJs0O_yttFpzaN3xdJ4_vMkk9jRhLB-PSbeszzCEANG7MupjhAqR7jlWgitWG1mq70ySPn7pUUJM20v9YyK8j5iZzK9goG12DdJ3t-cnC8-9jFKHir2jJ-VcpemzqHz_zT-8eE9TRTXLcHNTddF8sZwH4IwfQpFC2hbjfdTEMTvOE9X_5JnIBoEYchozyl3F0i0TDZVorKyTTW6C2GhEPod4N7S1nKg7rt-dhh4oFk1ynQlcpKQGz6sljNRtok5iwno3FOpwKtCOJjhH2LlkzhjOtRCa2L7C4ZnYyyFjF2_kr_U_GPYOYPCCvVU7BCVIwKVaCZ07HCrzmM3G7cRAS7zUyrAPKaoOBe6DKzdaCGB4iapt4wct-FjnbiLKX_jHORA-BCkEyFbDUqbYeH-xTlR64yIpQ8WTmClezH2yogaT-446bIyUVFojP7wMjNgOYdvu3V-5KfxrGQQRCuICJt1Wk7SsShyceK-n2Sd3_V5tv_tSHZ5lmTZ3FYj16XnkX9NVXsOjhLQWMbhW6qzwltGb4ftQ8-ygZU01nJKpxKBxql1jqQvoR0nylzZfcZtqYQfhdDmMd2YbHg9cLjPVzD05PaBWYBmKC0Gdcyr7i_-I47WdoxqTIjU3MgiIIDGFavaVw1d16Rb57pM3QmFeeIT2fKD8YfgZe1Ee0Mz9H1Q8rcVLcyQVIgtJ6ATaPZMpJDsdgYVxVBEJOg6325EV5bsPZm3zK3xGtBlGvFNO8BLyfmh2n8Pbez2maLTz548aZ6mKmM0VrFfEk0PJzgrPkRCxC5GoI0HvG9gHhzLO1q0SS35f7gY2CUsJMR278auRH2Icruiu-aQJAz2M9XKoytstv2uuLGmh_tBR-SQ==&aut=eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBZG1pbmlzdHJhdG9yIiwiZXhwIjoxNjQyNzczNjk4LCJzZXNzaW9uSWQiOiI3Y2QwYTk3MC03OWY5LTExZWMtYjk1OC0wYTU4MGFjNTAyMzciLCJ1c2VySWQiOiJmMjYxZjZhYy05NTMyLTQ2MWQtYmVhMi01YmQ4YTRmN2JmZGIiLCJ1c2VybmFtZSI6IkFkbWluaXN0cmF0b3IiLCJzb3VyY2UiOiJNQUlOIiwibWV0aG9kIjoiUE9TVCIsInJlcXVlc3RVUkwiOiJodHRwOi8vb3J1LWF1dGg6ODA4MC9sb2dpbiIsIm9ydUF1dGhvcml0aWVzIjpbIk9SVV9BRE1JTiIsIk9SVV9BRE1JTl9FWFRBVFRSUyIsIk9SVV9BRE1JTl9PUkdTIiwiT1JVX0FETUlOX1JPTEVTIiwiT1JVX0FETUlOX1VTRVJTIl19.W5L-BT-bqaGHcGbHDQcuu83q3ougamwaFVgLmO3xyfB26T0RijrBPj4gSXhjCHtbs_gOiJzhAnHMmcyWXT9qpg&locale=IT&cffGtwBaseUrl=https://dcj-test.crif.com/cff-brk-dobstd&scId=2253d9336826f26ea23eab3cf87da3a3bc78fde6&caid=QUIDTESTLOCAL_1001',
      identifier: ''
    }).pipe(delay(1000));
  }

  postIdentificationVerify(
    method: string,
    body: {
      businessId: string;
      ndg: string;
    },
    options?: Options
  ): Observable<IdentificationVerifyDTO> {
    return of<IdentificationVerifyDTO>({
      status: this.identificationVerifyAttemps >= 2 ? 'OK' : 'KO'
    }).pipe(
      delay(1000),
      map(res => {
        if (res.status === 'OK') {
          this.identificationVerifyAttemps = 0;
        } else {
          this.identificationVerifyAttemps++;
        }

        return res;
      })
    );
  }

  private listToOne<T>(fn: Observable<any>): Observable<T> {
    return fn.pipe(map(res => (res instanceof Array ? res[0] : res)));
  }
}
